import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ImagesWithCheckboxs } from "../../../../Constant";
import { IMAGE_WITH_CHECKBOX } from "../../../../Data/FormControl/CheckboxAndRadio";
import { DynamicImagesWithCheckbox } from "./DynamicImagesWithCheckbox";
import { CustomImagesWithCheckbox } from "./CustomImagesWithCheckbox";

const ImagesWithCheckbox = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={ImagesWithCheckboxs} span={IMAGE_WITH_CHECKBOX} />
        <CardBody>
          <div className="main-img-checkbox">
            <Row className="g-3">
              <CustomImagesWithCheckbox />
              <DynamicImagesWithCheckbox />
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImagesWithCheckbox;
